import { onMounted, onUnmounted } from "vue";
import { modalController } from "@ionic/vue";

export function useModalBack() {
  const back = () => {
    history.back();
    modalController.dismiss(null, "cancel");
  };

  const nativeBack = () => {
    modalController.dismiss(null, "cancel");
  };

  onMounted(() => {
    if (window) {
      history.pushState(null, "", location.href);
      window.addEventListener("popstate", nativeBack, { capture: true });
    }
  });

  onUnmounted(() => {
    if (window) {
      window.removeEventListener("popstate", nativeBack, { capture: true });
    }
  });

  return {
    back,
  };
}
